import axios from "axios";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getLiveUsers(payload) {
    const result = await axios.post(apiUrl + "/admin/live",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}


async function getAdminLoginHistory(payload) {
    const result = await axios.post(apiUrl + "/admin/get/loginhistory",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getAdminScripts(payload) {
    const result = await axios.post(apiUrl + "/admin/getscripts",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

export const AdminService = {
    getLiveUsers,
    getAdminScripts,
    getAdminLoginHistory
}